import React from 'react';
import { BookOpenIcon, SearchIcon, SignpostIcon, TimerIcon, UsersIcon } from 'lucide-react';
import type { Bonus } from '../data/bonuses';
const ICONS = {
  search: SearchIcon,
  helpers: UsersIcon,
  sign: SignpostIcon,
  book: BookOpenIcon,
  timer: TimerIcon
};
type BookCoverProps = {
  kicker: string;
  title: string;
  icon: Bonus['icon'];
  accent?: string;
  className?: string;
};

/**
 * Code-drawn bonus cover in the product look: Track Navy, a corner of the
 * clay oval with lane lines, a chalk badge with the bonus icon, the chalk
 * title and a coloured spine.
 */
export function BookCover({
  kicker,
  title,
  icon,
  accent = 'bg-hl',
  className = ''
}: BookCoverProps) {
  const Icon = ICONS[icon];
  return <div style={{
    containerType: 'inline-size'
  }} className={`cover-navy relative aspect-[3/4] overflow-hidden rounded-[6px] shadow-book ring-1 ring-black/40 ${className}`} data-id="element-72" data-mp="29htmv8fhkc7a">
      <span className={`absolute inset-y-0 left-0 w-[5%] ${accent}`} aria-hidden="true" data-id="element-73" data-mp="20fu86mry1k7i" />
      <svg viewBox="0 0 100 100" className="absolute -right-[38%] top-[8%] w-[120%]" aria-hidden="true" data-id="element-74" data-mp="19ahn1i6d9cmd">
        <circle cx="50" cy="50" r="40" fill="none" stroke="#C8452B" strokeOpacity=".55" strokeWidth="12" data-id="element-75" data-mp="1e1r8s7osnvsz" />
        {[34, 37, 40, 43, 46].map(r => <circle key={r} cx="50" cy="50" r={r} fill="none" stroke="#F5F1E8" strokeOpacity=".35" strokeWidth=".35" data-id="element-76" data-mp="zaqrdd62krkp" />)}
      </svg>
      <span className="absolute inset-0 bg-gradient-to-b from-black/5 via-transparent to-black/45" aria-hidden="true" data-id="element-77" data-mp="1s0qwnd4hg6o3" />
      <div className="relative flex h-full flex-col items-center px-[11%] pb-[9%] pt-[8%] text-center" data-id="element-78" data-mp="1wz0vbxpf1peg">
        <p className="font-display text-[5cqw] font-semibold uppercase tracking-[0.12em] text-chalk/85" data-id="element-79" data-mp="1izstsy5s6573">Track Coach Ready</p>
        <span className="mt-[3cqw] rounded-[1.6cqw] bg-hl px-[3.4cqw] py-[1.2cqw] font-display text-[4.4cqw] font-bold uppercase tracking-[0.08em] text-hl-ink" data-id="element-80" data-mp="1n48ywx7kl8l9">
          {kicker}
        </span>
        <span className="mt-[7cqw] flex h-[24cqw] w-[24cqw] items-center justify-center rounded-full bg-chalk shadow-book" data-id="element-81" data-mp="bobtzzjc6e2e">
          <Icon className="h-[12cqw] w-[12cqw] text-navy" strokeWidth={2.2} aria-hidden="true" data-id="element-82" data-mp="29al32pd0l1ty" />
        </span>
        <p className="mt-auto font-display text-[9.5cqw] font-bold uppercase leading-[1.02] text-chalk" data-id="element-83" data-mp="24jl99sz6yzvo">{title}</p>
      </div>
    </div>;
}